import useAppContext from 'flow/hooks/useAppContext';

interface EmojiLanguageHook {
    emojiPickerI18n: {
        search: string;
        search_no_results_1: string;
        search_no_results_2: string;
        pick: string;
        add_custom: string;
        categories: {
            activity: string;
            custom: string;
            flags: string;
            foods: string;
            frequent: string;
            nature: string;
            objects: string;
            people: string;
            places: string;
            search: string;
            symbols: string;
        };
        skins: {
            choose: string;
            1: string;
            2: string;
            3: string;
            4: string;
            5: string;
            6: string;
        };
    };
}

const useEmojiLanguage = (): EmojiLanguageHook => {
    const { i18next } = useAppContext();

    const emojiPickerI18n = {
        search: i18next.t('search'),
        search_no_results_1: i18next.t('search_no_results_1'),
        search_no_results_2: i18next.t('search_no_results_2'),
        pick: i18next.t('pick'),
        add_custom: i18next.t('add_custom'),
        categories: {
            activity: i18next.t('activity'),
            custom: i18next.t('custom'),
            flags: i18next.t('flags'),
            foods: i18next.t('foods'),
            frequent: i18next.t('frequent'),
            nature: i18next.t('nature'),
            objects: i18next.t('objects'),
            people: i18next.t('people'),
            places: i18next.t('places'),
            search: i18next.t('search_result'),
            symbols: i18next.t('symbols'),
        },
        skins: {
            choose: i18next.t('choose'),
            1: i18next.t('skins_default'),
            2: i18next.t('skins_light'),
            3: i18next.t('skins_medium-light'),
            4: i18next.t('skins_medium'),
            5: i18next.t('skins_medium-dark'),
            6: i18next.t('skins_dark'),
        },
    };

    return { emojiPickerI18n };
};

export default useEmojiLanguage;
